<template>
  <v-dialog v-model="isOpen"
    persistent
    scrollable
    fullscreen
    content-class="image-browser sideBySideBrowser">
    <v-card>
      <multiview-browser-header text="Stereo View" @closeModal="closeStereo"/>
      <stereo-browser-toolbar/>
      <stereo-browser-body/>
    </v-card>
  </v-dialog>
</template>

<script>
// imports
import { mapGetters, mapActions } from "vuex";
import multiviewBrowserHeader from "../multiview/MultiviewBrowserHeader";
import stereoBrowserToolbar from "./StereoBrowserToolbar";
import stereoBrowserBody from "./StereoBrowserBody";

// exports
export default {
  name: "StereoBrowser",
  components: {multiviewBrowserHeader, stereoBrowserToolbar, stereoBrowserBody},
  computed: {
    ...mapGetters(["stereoContext"]),
    isOpen() {
      return !!this.stereoContext;
    }
  },
  methods: {
    ...mapActions(["closeStereo"])
  }
};

</script>